import { render, staticRenderFns } from "./BearingsView.vue?vue&type=template&id=65a15be4&scoped=true&"
import script from "./BearingsView.vue?vue&type=script&lang=ts&"
export * from "./BearingsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a15be4",
  null
  
)

export default component.exports